import ControlsChevronDown from '@/external/icons/ControlsChevronDown';

const SeeMore: FC = () => (
  <span className="text-moon-10 font-medium text-bulma uppercase flex w-fit justify-center cursor-pointer">
    <ControlsChevronDown fontSize={24} color="bulma.100" />
  </span>
);

export default SeeMore;
